import { AssetFilterModel, AssetStoreFilter } from './asset-filter.model';

export class AssetSearchModel {
  filterModel: AssetFilterModel;
  assetStoreFilter: AssetStoreFilter;
  pageNumber: number;
  pageSize: number;
  results: any[];

  constructor() {
    this.filterModel = new AssetFilterModel();
    this.assetStoreFilter = new AssetStoreFilter();
    this.pageNumber = 1;
    this.pageSize = 100;
    this.results = [];
  }
}
